import './assets/styles/index.css';
import './assets/svg-sprite/__index';

import './lib/polyfills';
import Vue from 'vue';
import Router from 'vue-router';
import App from './App.vue';
import routes from './routes';
import store from './store';
import './registerServiceWorker';
import './filters';
import vClickOutside from 'v-click-outside';
import VueMeta from 'vue-meta';
 
Vue.use(Router);
Vue.use(vClickOutside);
Vue.use(VueMeta);

if (__DEVELOPMENT__) {
  Vue.config.productionTip = false;
  Vue.config.errorHandler = function(err, vm, info) {
    console.group('%cVUE ERROR', 'color:red');
    console.error('ERROR', err);
    console.log('VM', vm);
    console.log('%cINFO', 'color:green', info);
    console.groupEnd();
  };
}

new Vue({
  router: new Router({
    mode: 'history',
    base: __BASE_URL__,
    routes
  }),
  store,
  render: h => h(App)
}).$mount('#app');

// CSRF in axios defaults for all requests. It must be created on server first.
// const csrfToken = '--csrf-token-here';
// axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
